module.exports = __webpack_public_path__ + "img/home_industry.829a0e41.png";